import { useQuery } from "@tanstack/react-query";

import { getTrendingServices, TrendingServicesParams } from "../services/goHireService";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { TrendingServicesResponse } from "../types/trendingService.types";

interface UseTrendingServicesParams extends TrendingServicesParams {
  page?: number;
}

const SERVICES_PAGE_LIMIT = 10;

export const useTrendingServices = (params: UseTrendingServicesParams = {}) => {
  const { limit = SERVICES_PAGE_LIMIT, page = 1, ...filterParams } = params;
  const offset = (page - 1) * limit;

  return useQuery<TrendingServicesResponse, Error>({
    queryKey: [...GO_SERVICE_QUERY_KEYS.trendingServices(), { limit, offset, ...filterParams }],
    queryFn: () => getTrendingServices({ limit, offset, ...filterParams }),
    staleTime: 1000 * 60 * 5,
  });
};
